import styled from "styled-components";
import { colors, devicesNovo } from "../../utils/styled/_variables.styled";

export const SonharMorarContainer = styled.div`
  > div:nth-child(2) {
    p {
      text-align: start;
      font-weight: 400;
      font-size: 16px;
      line-height: 175%;
      color: ${colors.gray2};
      @media ${devicesNovo.smallDesktop} {
        margin-top: 18px;
      }
    }
  }

  .sonharmorar__content {
    width: 100%;
    padding: 30px 20px 0px 20px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    @media ${devicesNovo.smallDesktop} {
      padding: 30px 20px 0px 20px;
    }
    > div {
      display: flex;
      flex-direction: column;
      /* gap: 24px; */
      max-width: 810px;
      @media ${devicesNovo.smallDesktop} {
        flex-direction: row;
        gap: 24px;
        max-width: 820px;
      }
    }
    > div > div:nth-child(1) {
      @media ${devicesNovo.smallDesktop} {
        flex: 1;
      }
    }
    > div > div:nth-child(2) {
      display: flex;
      flex-direction: column;
      /* gap: 24px; */
      max-width: 810px;
      @media (min-width: 900px) {
        flex: 2;
      }
    }
  }
`;
